import {
    BottomSheetContent as UiBottomSheetContent,
    styled,
} from "@l2r-front/l2r-ui"

export const BottomSheetContent = styled(UiBottomSheetContent)(({ isMobile }) => ({
    display: "flex",
    flexDirection: "column",
    minHeight: isMobile && "100%",
}))